export default {
    MAX_TITLE_LENGTH: 255,
    MAX_TITLE_LENGTH_IN_RATING: 55,
};
